export default __webpack_public_path__ + "static/media/map-pin.3a8038b3.svg";